export const optionTitle_mailHandling = "iirK$d";
export const optionSearch_mailHandling = "Ortqwc";
export default {optionTitle_mailHandling,optionSearch_mailHandling};